module.exports = __webpack_public_path__ + "img/fullline.b19e0493.svg";